import { render, staticRenderFns } from "./templates-dynamic-field.vue?vue&type=template&id=04df6b63&scoped=true&lang=pug"
import script from "./templates-dynamic-field.vue?vue&type=script&lang=js"
export * from "./templates-dynamic-field.vue?vue&type=script&lang=js"
import style0 from "./templates-dynamic-field.vue?vue&type=style&index=0&id=04df6b63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04df6b63",
  null
  
)

export default component.exports